import React, { useState, Fragment } from 'react'
import { graphql } from "gatsby"

import Head from "../components/Head"
import Layout from "../components/Layout"
import Article from "../components/Article"


export default function BlogPage({ data }) {
  const articles = data.allMarkdownRemark.edges.map(({node}) => node)
  const [numberOfArticlesDisplayed, setNumberOfArticlesDisplayed] = useState(4)

  const seeMoreArticles = () => setNumberOfArticlesDisplayed(prevState => prevState + 3)
  const seeLessArticles = () => {
    if(numberOfArticlesDisplayed < 7) return setNumberOfArticlesDisplayed(4)
    setNumberOfArticlesDisplayed(prevState => prevState - 3)
  }


  return (
    <>
      <Head title="Articles | Maxime BOUNAAS-FERRET" />
      <Layout>
        <section id="blog">
          <div className="text_block">
            <h2 className="title_deco">Mes articles</h2>
            <i>
              Retrouvez ici mes idées, apprentissages, et en règle général tout ce que j'apprécie partager sur le business en ligne, le digital, la tech...
            </i>
          </div>

          <ul className="articles">
            {Array(numberOfArticlesDisplayed).fill().map((_, i) => (
              <Fragment key={i}>
                {articles[i] && <Article article={articles[i]} />}
              </Fragment>
            ))}
          </ul>

          <div className="buttonsRow">
              <div 
                className={`seeMoreBtn ${!(numberOfArticlesDisplayed < articles.length) && "disabled"}`} 
                onClick={seeMoreArticles}
                disabled={!(numberOfArticlesDisplayed < articles.length)}
              >
                Voir plus
              </div>
              <div 
                className={`seeMoreBtn ${numberOfArticlesDisplayed === 4 && "disabled"}`} 
                onClick={seeLessArticles}
                disabled={numberOfArticlesDisplayed === 4}
              >
                Voir moins
              </div>
          </div>
        </section>
      </Layout>
    </>
  )
}


export const articlesQuery = graphql`
  query BlogPosts {
    allMarkdownRemark(sort: {fields: frontmatter___createdAt, order: DESC}) {
      edges {
        node {
          html
          frontmatter {
            createdAt
            img
            path
            title
          }
        }
      }
    }
  }
`
